<mat-form-field style="padding-right:20px">
  <mat-select type="text" matInput [formControl]="clientControl" (selectionChange)="selectDataspace($event)">
    <mat-option *ngFor="let dataspace of dataspaces" [value]="dataspace">{{dataspace}}</mat-option>
  </mat-select>
</mat-form-field>
